import Vue from 'vue'
import VueRouter from 'vue-router'
import './dynamice-router'
import error from '../views/errorpage/index404.vue'

Vue.use(VueRouter)

const routes = [
  
  {
    path: '/',
    name: 'homepage',
    component: () => import( '../views/homepage'),
    meta:{
      requireAuth:false,
      label:'首页',
    },
    children:[
      {
        path: '/homeArticle',
        name: 'homeArticle',
        component: () => import( '../views/homepage/homeArticle/index.vue'),
        meta:{
          requireAuth:false,
          label:'首页',
        },
        children:[
          {
            path: '/ArticleHomepage',
            name: 'ArticleHomepage',
            component: () => import( '../views/homepage/homeArticle/ArticleHomepage'),
            meta:{
              requireAuth:false,
              label:'文章首页',
            },
          },
          {
            path: '/newHomepage',
            name: 'newHomepage',
            component: () => import( '../views/homepage/homeArticle/newHomepage'),
            meta:{
              requireAuth:false,
              label:'文章首页',
            },
          },
          {
            path: '/PhotoLive',
            name: 'PhotoLive',
            component: () => import( '../views/homepage/homeArticle/PhotoLive'),
            meta:{
              requireAuth:false,
              label:'照片直播',
            },
          },
          {
            path: '/VideoLive',
            name: 'VideoLive',
            component: () => import( '../views/homepage/homeArticle/VideoLive'),
            meta:{
              requireAuth:false,
              label:'视频直播',
            },
          },
          {
            path: '/GagsVideo',
            name: 'GagsVideo',
            component: () => import( '../views/homepage/homeArticle/GagsVideo'),
            meta:{
              requireAuth:false,
              label:'视频花絮',
            },
          },
          {
            path: '/SearchFor',
            name: 'SearchFor',
            component: () => import( '../views/homepage/homeArticle/SearchFor'),
            meta:{
              requireAuth:false,
              label:'搜索',
            },
          },
        ],
        redirect:'/newHomepage',
      },
    ],
    redirect:'/homeArticle',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '../views/login'),
    meta:{
      requireAuth:false,
      label:'登录',
    },
  },
  {
    path: '/DataV',
    name: 'DataV',
    component: () => import( '../views/DataV'),
    meta:{
      requireAuth:false,
      label:'数据可视化',
    },
  },
  {
    path: '/DataTree',
    name: 'DataTree',
    component: () => import( '../views/DataTree'),
    meta:{
      requireAuth:false,
      label:'树形结构',
    },
  },
  // {}
]

export const DynamicRoutes= [
  {
    path: '/home',
    name: 'home',
    component: () => import( '../views/home'),
    meta:{
      requireAuth:true,
      name: 'home',
      label:'主页'
    },
    children:[
     
    ]
  },
  {
    path: '/index404',
    component: error,
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
